import { render } from "./GalleryCard.vue?vue&type=template&id=31521e6e&scoped=true"
const script = {}

import "./GalleryCard.vue?vue&type=style&index=0&id=31521e6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31521e6e"

export default script